/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Region } from '../../models/region';

export interface GetRegions$Params {
}

export function getRegions(http: HttpClient, rootUrl: string, params?: GetRegions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Region>>> {
  const rb = new RequestBuilder(rootUrl, getRegions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Region>>;
    })
  );
}

getRegions.PATH = '/region';
